<template>
    <div id="app">
        <main-header nowtab="play"></main-header>
        <main class="adjuster">
            <a-card size="small" class="card dashboard-card">
                <a-input-group>
                    <a-row :gutter="8">
                        <a-col :span="5">
                            <a-radio-group v-model="sortmode" @change="onChange">
                                <a-radio-button value="hotest">
                                    最热
                                </a-radio-button>
                                <a-radio-button value="latest">
                                    最新
                                </a-radio-button>
                            </a-radio-group>
                        </a-col>
                        <a-col :span="14">
                            <a-input-search placeholder="查找魔塔" enter-button />
                        </a-col>
                        <a-col class="advanced-filter-btn">
                            <a-checkable-tag :checked="advancedFilter" @change="openFilter">高级筛选</a-checkable-tag>
                        </a-col>
                    </a-row>
                </a-input-group>
                <div class="advanced-filter" style="height:0px" ref="advancedFilter">
                    按标签筛选:
                    <a-checkable-tag
                        v-for="tag in tags" :key="tag"
                        :checked="selectedTags.indexOf(tag) > -1"
                        @change="checked => handleSelectTag(tag, checked)"
                    >
                        {{ tag }}
                    </a-checkable-tag>
                    <a-tag @click="selectAll">全选</a-tag>
                    <a-tag @click="clearTags">清空</a-tag>
                    <br/>
                    按目录筛选:
                    <a-checkable-tag></a-checkable-tag>
                </div>
                <div class="color-select">
                    <span class="colormode" :style="{ color: colormodenow.color }">
                        {{ colormodenow.description }}
                        <span v-for="mode of leftcolors" :key="mode.key" 
                            :style="{ color: mode.color }" class="switch"
                            @click="changeColor(mode.key)"
                        >{{ mode.name }}</span>
                    </span>
                    <a class="color-helper" @click="colorHelp" href="javascript:void 0">
                        <a-icon type="question-circle" />关于颜色系统
                    </a>
                </div>
            </a-card>
            <a-pagination :current="Number(page)" :total="total" 
                :defaultPageSize="20" @change="turnPage" :hideOnSinglePage="true"
            />
            <div>
                <a class="rand" href="javascript:void 0">不满意？换一批！</a>
            </div>
            <ul class="tower-list">
                <main-tower-card></main-tower-card>
                <main-tower-card></main-tower-card>
                <main-tower-card></main-tower-card>
                <main-tower-card></main-tower-card>
            </ul>
        </main>
        <Footer></Footer>
    </div>
</template>

<script>
import MainHeader from '@/components/MainHeader.vue';
import Footer from '@/components/Footer.vue';
import MainTowerCard from '../../components/MainTowerCard.vue';
import { TAGS } from '../../constant';
import { transitionAttr } from '../../utils/utils';

const COLOR_MODES = [
    { key: '2|3', name: '蓝绿区', description: '当前位于蓝绿区', color: '#008000' },
    { key: '1|4', name: '红橙区', description: '当前位于红橙区', color: '#FF0000' },
    { key: '0|5', name: '白紫区', description: '当前位于白紫区', color: '#800080' },
    { key: '#', name: '所有塔', description: '当前显示所有塔', color: '#000000' },
];

export default {
    data: () => ({
        page: 1,
        total: 0,
        sortmode: 'hotest',
        colormode: '2|3',
        tags: TAGS,
        advancedFilter: false,
        selectedTags: [],
        customStyle:
            'background: #f7f7f7;border-radius: 4px;overflow: hidden',
    }),
    computed: {
        colormodenow() {
            return COLOR_MODES.find(e => e.key == this.colormode);
        },
        leftcolors() {
            return COLOR_MODES.filter(e => e.key != this.colormode);
        },
    },
    created() {
        // getSSRdata();
    },
    methods: {
        turnPage(page) {
            this.page = page;
        },
        onChange() {
            
        },
        colorHelp() {
            this.$info({
                title: '颜色系统说明',
                content: h => (
                    <div>
                        <table border="1" cellspacing="0" style="text-align:center">
                            <tbody>
                                <tr><td colspan="2" rowspan="2"><b>颜色标注</b></td><td colspan="3"><b>游戏体验感</b></td></tr>
                                <tr><td>良好</td><td>一般</td><td>较差</td></tr>
                                <tr><td rowspan="2"><b>难度</b></td><td>较难</td><td style="background:lightgreen">浅绿</td><td style="background:#FFC088">浅橙</td><td style="background:#FF9999">浅红</td></tr>
                                <tr><td>一般</td><td style="background:lightblue">浅蓝</td><td style="rgba(252,252,252,0.2)">无色</td><td style="background:#ded0ff">淡紫</td></tr>
                            </tbody>
                        </table>
                        <p></p>
                        <p>
                            <b>游戏体验感：</b>主要面向广大休闲玩家。
                        </p>
                        <ul>
                            <li>良好：美工、剧情或创新等方面较为突出，能吸引人（尤其是广大休闲玩家）玩下去。</li>
                            <li>一般：中规中矩，并不突出，但是也不让人感到不适。</li>
                            <li>较差：让人感到不适，比如满屏阻激夹域血网自爆等恶心属性，或者界面比较瞎眼。</li>
                        </ul>
                        <b>难度：</b>主要面向有一定拆塔水平的硬核玩家。
                        <ul>
                            <li>较难：最高难度通关有一定的难度，或者比较具有研究价值。</li>
                            <li>一般：难度不是特别高，也不怎么具有反复研究的价值。</li>
                        </ul>
                    </div>
                ),
                onOk() {},
            });
        },
        handleSelectTag(tag, checked) {
            const { selectedTags } = this;
            const nextSelectedTags = checked
                ? [...selectedTags, tag]
                : selectedTags.filter(t => t !== tag);
            this.selectedTags = nextSelectedTags;
        },
        selectAll() {
            this.selectedTags = [ ...this.tags ];
        },
        clearTags() {
            this.selectedTags = [];
        },
        openFilter() {
            if (this.advancedFilter) {
                transitionAttr(this.$refs.advancedFilter, "height", "0px", 300);
            } else {
                transitionAttr(this.$refs.advancedFilter, "height", "auto", 300);
            }
            this.advancedFilter = !this.advancedFilter;
        },
        changeColor(color) {
            this.colormode = color;
        }
    },
    components: {
        MainHeader, Footer,
        MainTowerCard,
    },
};
</script>

<style>
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
}
body {
    background-color: #e6e6e6 !important;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    cursor: default;
}
</style>

<style lang="less" scoped>
.adjuster {
    width: 100%;
    margin: 20px auto;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.dashboard-card {
    @media screen and (min-width: 1000px) {
        width: 1000px;
    }
    @media screen and (max-width: 999px) {
        width: 100%;
    }
}
.card {
    background-color: #f6f6f6;
    border-radius: 2px;
    -webkit-box-shadow: 0 1px 3px rgba(18,18,18,.1);
    box-shadow: 0 1px 3px rgba(18,18,18,.1);
    margin: 6px;
}
.advanced-filter-btn {
    line-height: 32px;
}
.advanced-filter {
    padding-top: 10px;
    text-align: left;
    line-height: 24px;
    overflow: hidden;
}
.color-select {
    margin-top: 8px;
}
.colormode {
    font-weight: bold;
    font-size: 18px;
    margin: 0px 5px;
    .switch {
        font-size: 16px;
        margin: 3px;
        cursor: pointer;
    }
}
.color-helper {
    font-size: 12px;
    color: inherit;
}
.rand {
    color: red;
    font-weight: bold;
}
.tower-list {
    width: 100%;
    margin: 10px 0;
    padding: 0;
    width: 90%;
    @media screen and (max-width: 600px) {
        width: 96%;
    }
}
</style>

<style scoped>
/* For demo */
.ant-carousel >>> .slick-slide {
  text-align: center;
  height: 320px;
  line-height: 320px;
  background: #364d79;
  overflow: hidden;
}

.ant-carousel >>> .slick-slide h3 {
  color: #fff;
}
</style>

<style lang="less" scoped>
.towers, .bbs {
    max-width: 1000px;
    margin: 0 auto;
}
</style>
